
define('text!modules/creatives/concept/templates/bin_item.html',[],function () { return '<div class="detail name creative-list-name">\n\t<div class="item-c icon include active" data-action="include"></div>\n\t<div class="item-c text" title="{{full_path}}">{{full_path_end}}</div>\n</div>';});

